export default "__VITE_ASSET__8h3PN2NT__"